import { IContrapartesWs } from "../interfaces/Workspace"
import { getQueryParameter } from "../util/helpers"
import { get } from "./fetch"


export const getContrapartesWs = async (): Promise<IContrapartesWs[]> => {
    var contrapartesWs:IContrapartesWs[] = await get('/api/contrapartes-ws')
    return contrapartesWs
}

export const getCantidadContrapartes = async (queryParams?:{
    unidad?:string}): Promise<number> => {
        let queryString = getQueryParameter(queryParams);
    var cantidadContrapartes:number = await get(`/api/socios/cantidad${queryString}`)
    return cantidadContrapartes
}